export default __webpack_public_path__ + "static/media/Users.bb6a07ef.svg";